import React from "react";
import "./trafficLightIndicator.css";

const TrafficLightIndicatorLifeStyle = ({ category, riskLevel, recommendation }) => {
  let textRisk = ""
  // Asignar color según el nivel de riesgo
  const getColor = (level) => {
    switch (level) {
      case 0:
        textRisk = "Habitos muy saludables"
        return "green";
      case 1:
        textRisk = "Habitos saludables"
        return "green";
      case 2:
        textRisk = "Habitos poco saludables"
        return "yellow";
      case 3:
        textRisk = "Habitos nada saludables"
        return "red";
      default:
        return "gray";
    }
  };

  return (
    <div className="traffic-light-indicator">
      <h3 className="category-title">&nbsp;</h3>
      <div className={`traffic-light ${getColor(riskLevel)}`}>
        {textRisk}
      </div>
      <p className="recommendation">{recommendation}</p>
    </div>
  );
};

export default TrafficLightIndicatorLifeStyle;
